import { type FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useIsFeatureAdvertisementEnabled } from '../../common/useIsFeatureAdvertisementEnabled'
import { useZocksQuota } from '../ScopedBlock/hooks'

interface FeatureAdvertisementRouteProps {
  bypassQuotas?: string[]
  redirectTo?: string
}

export const FeatureAdvertisementRoute: FC<FeatureAdvertisementRouteProps> = ({ bypassQuotas = [], redirectTo = '/' }) => {
  const { hasQuota, isFetching: isQuotasFetching } = useZocksQuota()
  const bypass = bypassQuotas.some((quota) => hasQuota(quota))
  const { isEnabled, isFetching: isAccountFetching } = useIsFeatureAdvertisementEnabled({ bypass })

  if (isQuotasFetching || isAccountFetching) {
    return null
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />
  }

  return <Outlet />
}
